import {
  LIST_UNIT_FETCH,
  LIST_UNIT_SUCCESS,
  LIST_UNIT_REJECTED,
  LIST_CURRENCY_FETCH,
  LIST_CURRENCY_SUCCESS,
  LIST_CURRENCY_REJECTED,
  GET_DEPARTMENT_FETCH,
  GET_DEPARTMENT_SUCCESS,
  GET_DEPARTMENT_REJECTED,
  GET_LOCATION_FETCH,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_REJECTED,
  GET_BRAND_FETCH,
  GET_BRAND_SUCCESS,
  GET_BRAND_REJECTED,
  LIST_COUNTRIES_FETCH,
  LIST_COUNTRIES_SUCCESS,
  LIST_COUNTRIES_REJECTED,
} from "src/Constants";

const initialState = {
  units: { data: [], isLoading: false, isError: false },
  currencies: { data: [], isLoading: false, isError: false },
  allDepartments: { data: [], isLoading: false, isError: false },
  locations: { data: [], isLoading: false, isError: false },
  allBrands: { data: [], isLoading: false, isError: false },
  countries: { data: [], isLoading: false, isError: false },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LIST_COUNTRIES_FETCH:
      return {
        ...state,
        countries: { isLoading: true, isError: false },
      };
    case LIST_COUNTRIES_SUCCESS:
      return {
        ...state,
        countries: {
          data: action.payload,
          isLoading: false,
          isError: false,
        },
      };
    case LIST_COUNTRIES_REJECTED:
      return {
        ...state,
        countries: { isLoading: false, isError: true },
      };

    case GET_BRAND_FETCH:
      return {
        ...state,
        allBrands: { isLoading: true, isError: false },
      };
    case GET_BRAND_SUCCESS:
      return {
        ...state,
        allBrands: {
          data: action.payload,
          isLoading: false,
          isError: false,
        },
      };
    case GET_BRAND_REJECTED:
      return {
        ...state,
        allBrands: { isLoading: false, isError: true },
      };

    case GET_LOCATION_FETCH:
      return {
        ...state,
        locations: { isLoading: true, isError: false },
      };
    case GET_LOCATION_SUCCESS:
      return {
        ...state,
        locations: {
          data: action.payload,
          isLoading: false,
          isError: false,
        },
      };
    case GET_LOCATION_REJECTED:
      return {
        ...state,
        locations: { isLoading: false, isError: true },
      };
    case GET_DEPARTMENT_FETCH:
      return {
        ...state,
        allDepartments: { isLoading: true, isError: false },
      };
    case GET_DEPARTMENT_SUCCESS:
      return {
        ...state,
        allDepartments: {
          data: action.payload,
          isLoading: false,
          isError: false,
        },
      };
    case GET_DEPARTMENT_REJECTED:
      return {
        ...state,
        allDepartments: { isLoading: false, isError: true },
      };

    case LIST_UNIT_FETCH:
      return { ...state, units: { isLoading: true, isError: false } };
    case LIST_UNIT_SUCCESS:
      return {
        ...state,
        units: { data: action.payload, isLoading: false, isError: false },
      };
    case LIST_UNIT_REJECTED:
      return { ...state, units: { isLoading: false, isError: true } };
    case LIST_CURRENCY_FETCH:
      return { ...state, currencies: { isLoading: true, isError: false } };
    case LIST_CURRENCY_SUCCESS:
      return {
        ...state,
        currencies: { data: action.payload, isLoading: false, isError: false },
      };
    case LIST_CURRENCY_REJECTED:
      return { ...state, currencies: { isLoading: false, isError: true } };
    default:
      return state;
  }
};
